import React, { useEffect, useState } from "react";
import { baseURL, PROJECTS, TAGS } from "../../../Api/Api";
import { useTranslation } from "react-i18next";
import { Axios } from "../../../Api/axios";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

function PortfolioSection() {
  const [projects, setProjects] = useState([]);
  const [tags, setTags] = useState([]);
  const [activeFilter, setActiveFilter] = useState("*");
  const { i18n } = useTranslation(); // Get the current language

  // Fetch projects with associated tags
  useEffect(() => {
    Axios.get(`${baseURL}/${PROJECTS}/view`)
      .then((response) => {
        if (Array.isArray(response.data)) {
          setProjects(response.data);
        } else {
          console.error("API response is not an array:", response.data);
        }
      })
      .catch((error) => console.error("Error fetching PROJECTS:", error));
  }, []);

  // Fetch all tags
  useEffect(() => {
    Axios.get(`${baseURL}/${TAGS}/view`)
      .then((response) => setTags(response.data))
      .catch((error) => console.error("Error fetching tags:", error));
  }, []);

  // Handle filter click with trimming and lowercasing
  const handleFilterClick = (filter) => {
    const normalizedFilter = filter.trim().toLowerCase();
    setActiveFilter(normalizedFilter);
  };

  // Filter projects directly in render logic
  const projectsdata = projects
    .filter((project) => {
      const projectTagName = project.tag?.name_en?.trim().toLowerCase() || "";
      return activeFilter === "*" || projectTagName === activeFilter;
    })
    .map((project) => {
      const backgroundImage = project.images?.find(
        (img) => img.is_background === 1
      );

      // Determine the language to display
      const isArabic = i18n.language === "ar";
      const title = isArabic ? project.title_ar : project.title_en;
      const description = isArabic ? project.desc_ar : project.desc_en;

      return (
        <div
          key={project.id}
          className="col-lg-4 col-md-6 portfolio-item isotope-item"
        >
          <div className="portfolio-content h-100">
            {backgroundImage && (
              <Image
                src={backgroundImage.path}
                className="img-fluid"
                alt={title}
              />
            )}
            <div className="portfolio-info">
              <h4>{title}</h4>
              <p>{description}</p>
              {backgroundImage && (
                <a
                  href={backgroundImage.path}
                  title={title}
                  className="glightbox preview-link"
                >
                  <i className="bi bi-zoom-in" />
                </a>
              )}
              <Link
                to={`/portfolio/${project.id}`}
                title="More Details"
                className="details-link"
              >
                <i className="bi bi-link-45deg" />
              </Link>
            </div>
          </div>
        </div>
      );
    });

  // Render tags with normalized comparison
  const tagsdata = (
    <ul className="portfolio-filters isotope-filters">
      <li
        onClick={() => handleFilterClick("*")}
        className={activeFilter === "*" ? "filter-active" : ""}
      >
        {i18n.language === "ar" ? "الكل" : "All"}
      </li>
      {tags.map((tag) => {
        const normalizedTagName = tag.name_en.trim().toLowerCase();
        const isArabic = i18n.language === "ar";
        const tagName = isArabic ? tag.name_ar : tag.name_en;

        return (
          <li
            key={tag.id}
            onClick={() => handleFilterClick(tag.name_en)}
            className={
              activeFilter === normalizedTagName ? "filter-active" : ""
            }
          >
            {tagName}
          </li>
        );
      })}
    </ul>
  );

  return (
    <section id="portfolio" className="portfolio section">
      <div className="container">
        <div
          className="isotope-layout"
          data-default-filter="*"
          data-layout="masonry"
          data-sort="original-order"
        >
          {tagsdata}
          <div className="row gy-4 isotope-container">{projectsdata}</div>
        </div>
      </div>
    </section>
  );
}

export default PortfolioSection;
